import api from './api';

export const REPORT_TIME_DEFAULTS = Object.freeze({
  fromTime: '06:00',
  toTime: '22:00',
});

export const resolveReportTimeRange = (fromTime, toTime) => ({
  fromTime: fromTime || REPORT_TIME_DEFAULTS.fromTime,
  toTime: toTime || REPORT_TIME_DEFAULTS.toTime,
});

export const normalizeBranchScope = (branchOrId) => {
  if (!branchOrId) return 'all';

  if (typeof branchOrId === 'object') {
    const { id, isAllOutlets } = branchOrId || {};
    if (isAllOutlets || id === 'all-outlets' || id === 'all') {
      return 'all';
    }
    return id ? String(id) : 'all';
  }

  const value = String(branchOrId).trim();
  if (!value || value === 'all-outlets' || value === 'all') {
    return 'all';
  }

  return value;
};

const buildParams = (startDate, endDate, branchId, fromTime, toTime, extras = {}) => {
  const { fromTime: safeFromTime, toTime: safeToTime } = resolveReportTimeRange(fromTime, toTime);
  const params = {
    from_date: startDate,
    to_date: endDate,
    start_date: startDate,
    end_date: endDate,
    from_time: safeFromTime,
    to_time: safeToTime,
    ...extras,
  };

  const normalizedBranchId = normalizeBranchScope(branchId);
  params.branch_id = normalizedBranchId;

  return params;
};

export const reportService = {
  resolveBranchScope: (selectedBranch, branchIdOverride) => {
    if (branchIdOverride && branchIdOverride !== 'all-outlets' && branchIdOverride !== 'all') {
      return String(branchIdOverride);
    }

    return normalizeBranchScope(selectedBranch || branchIdOverride || 'all');
  },

  getBranchSalesSummary: (startDate, endDate, branchId, fromTime, toTime) => {
    return api.get('/web/reports/sales-summary/', {
      params: buildParams(startDate, endDate, branchId, fromTime, toTime),
    });
  },

  getBranchItemsSummary: (startDate, endDate, branchId, fromTime, toTime, orderType) => {
    return api.get('/web/reports/items-summary/', {
      params: buildParams(startDate, endDate, branchId, fromTime, toTime, {
        order_type: orderType && orderType !== 'all' ? orderType : undefined,
      }),
    });
  },

  getBranchCategorySummary: (startDate, endDate, branchId, fromTime, toTime) => {
    return api.get('/web/reports/category-summary/', {
      params: buildParams(startDate, endDate, branchId, fromTime, toTime),
    });
  },

  getBranchCounterSummary: (startDate, endDate, branchId, fromTime, toTime) => {
    return api.get('/web/reports/counter-summary/', {
      params: buildParams(startDate, endDate, branchId, fromTime, toTime),
    });
  },

  getBranchCaptainWiseSummary: (startDate, endDate, branchId, fromTime, toTime) => {
    return api.get('/web/reports/captain-wise-summary/', {
      params: buildParams(startDate, endDate, branchId, fromTime, toTime),
    });
  },

  getBranchSalesReport: (startDate, endDate, branchId, fromTime, toTime, paymentType) => {
    return api.get('/web/reports/sales-report/', {
      params: buildParams(startDate, endDate, branchId, fromTime, toTime, {
        payment_type: paymentType || undefined,
      }),
    });
  },

  getBranchPaymentSummary: (startDate, endDate, branchId, fromTime, toTime) => {
    return api.get('/web/reports/payment-summary/', {
      params: buildParams(startDate, endDate, branchId, fromTime, toTime),
    });
  },
};
